import type { PlaceOrderPayload } from "@/hooks/useHandlePlaceOrderRequest";
import type { OrderType } from "@/components/TradingView/useTradingViewState";

/** The last order this tab successfully placed, for the repeat hotkeys
 * (ctrl+R / ctrl+shift+R). Per-tab and per-session on purpose: "repeat my
 * last order" means the one just placed here, not one from another device. */
export interface LastOrderRecord {
  marketKey: string;
  request: PlaceOrderPayload;
  orderType: OrderType;
}

let last: LastOrderRecord | null = null;

export function setLastOrder(record: LastOrderRecord): void {
  last = record;
}

export function getLastOrder(): LastOrderRecord | null {
  return last;
}

/**
 * One-shot amount prefill for the trade ticket, set by the repeat hotkeys.
 * Held here (not in React state) because the SwapPanel may remount when the
 * hotkey also flips the side or market: the form consumes a pending prefill
 * on mount, and an already-mounted form is nudged through the listener.
 */
let pendingAmount: string | null = null;
const prefillListeners = new Set<() => void>();

export function requestAmountPrefill(amount: string): void {
  pendingAmount = amount;
  for (const listener of prefillListeners) listener();
}

export function consumeAmountPrefill(): string | null {
  const amount = pendingAmount;
  pendingAmount = null;
  return amount;
}

export function onAmountPrefill(listener: () => void): () => void {
  prefillListeners.add(listener);
  return () => prefillListeners.delete(listener);
}
